import { observer } from 'mobx-react'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import DayCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/DayCell'
import type {
  Column,
  ColumnsType,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  visibleDefaultShifts: DefaultShifts
}

const BasicRow = ({ shiftsRow, columns, visibleDefaultShifts }: Props) => {
  return (
    <>
      {columns.map((column: Column) => {
        return (
          <WrapperCell
            key={`DayCell-${shiftsRow.key}-${column.formattedDate}`}
            minWidth={column.minWidth}
          >
            <DayCell
              date={column.date}
              shiftsRow={shiftsRow}
              visibleDefaultShifts={visibleDefaultShifts}
            />
          </WrapperCell>
        )
      })}
    </>
  )
}

export default observer(BasicRow)
